import React from 'react';
import { Images } from 'utils';
import { DateRow, EditWithIcon, TextRow } from 'components';

export const assessmentHead = [
    { name: 'name', title: 'Assessment Name', noSearch: true },
    { name: 'tool', title: 'Tool', noSearch: true, multiple: true, filterList: [{ name: 'VB-Mapp', id: 'VB_MAPP' }] },
    { name: 'creator', title: 'Creator', noSearch: true, disabled: true },
    { name: 'startDate', title: 'Start Date', noSearch: true, disabled: true },
    // { name: 'action', title: 'Action', noSearch: true, custom: false, width: '100px' },
];

export const assessmentBody = (renderParams) => [
    { rowText: (item) => <TextRow name={renderAssessmentName(item?.type)} /> },
    { rowText: (item) => <TextRow name={renderAssessmentName(item?.type)} /> },
    // { rowText: (item) => <TextRow name={item?.name} /> },
    { rowText: (item) => <TextRow name={item?.assessor} /> },
    { rowText: (item) => <DateRow date={item?.startDate} /> },
    // {
    //     button: (fn) =>
    //         <div className="flex-align-center" style={{ gap: 12 }}>
    //             {/*<EditWithIcon*/}
    //             {/*    icon={Images.edit}*/}
    //             {/*    handleClick={() => fn('edit')}*/}
    //             {/*/>*/}
    //             <EditWithIcon
    //                 icon={Images.deleteTag}
    //                 handleClick={() => fn('delete')}
    //             />
    //         </div>, notClickable: true,
    // },
];

export const ACTION_TYPE = 'GET_ASSESSMENTS';

export const goalNotYet = {
    title: 'No Assessments Information',
    subTitle: 'Start by adding your first Assessment to manage their information.',
    image: Images.noClientYet,
};

export const assessmentEnums = {
    vbMapp: 'vbMapp',
};

export const assessmentList = [{ name: 'vbMapp', id: assessmentEnums.vbMapp }];

export const scoresHead = [
    { name: 'name', title: 'Question #', noSearch: true, custom: false },
    // { name: 'tool', title: 'Domain', noSearch: true, custom: false },
    { name: 'creator', title: 'Score', noSearch: true, custom: false },
    { name: 'creator', title: 'Timestamp', noSearch: true, custom: false },
    { name: 'creator', title: 'Area', noSearch: true, custom: false },
    { name: 'startDate', title: 'Group', noSearch: true, custom: false },
];

export const scoresBody = [
    { rowText: (item) => <TextRow name={item?.questionNum} /> },
    // { rowText: (item) => <TextRow name={item?.domain} /> },
    { rowText: (item) => <TextRow name={item?.score} /> },
    { rowText: (item) => <DateRow date={item?.timestamp} /> },
    { rowText: (item) => <TextRow name={item?.area} /> },
    { rowText: (item) => <TextRow name={item?.group} /> },
];

export const scorNotYet = {
    height: '300px',
    title: 'No Scores Information',
    subTitle: 'Start by adding your first Score to manage their information.',
    image: Images.noClientYet,
};

export const renderAssessmentName = (type) => {
    switch (type) {
        case 'VB_MAPP':
            return 'VB-Mapp';
        default:
            return type;
    }
};
